import { render, staticRenderFns } from "./AulasLancadas.vue?vue&type=template&id=2c64929c&scoped=true&"
import script from "./AulasLancadas.vue?vue&type=script&lang=js&"
export * from "./AulasLancadas.vue?vue&type=script&lang=js&"
import style0 from "./AulasLancadas.vue?vue&type=style&index=0&id=2c64929c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64929c",
  null
  
)

export default component.exports